import { calculatePltv } from './modules';
import { initSentry } from './modules/sentry';
import { uaToDeviceType, uaToOSName } from './modules/userAgent';
import { PLTV_URL } from './modules/constants';

var getCourse = function getCourse() {
  return (document.querySelector('head').dataset || {}).emCourse;
};

var API = {
  getCourse: getCourse,
  initSentry: initSentry,
  uaToDeviceType: uaToDeviceType,
  uaToOSName: uaToOSName,
  calculatePltv: calculatePltv
};

var setupConfig = function setupConfig() {
  window._eePltvConfigV2.PLTV_URL = window._eePltvConfigV2.PLTV_URL || PLTV_URL;
};

var initialize = function initialize() {
  window._eePltvConfigV2 = window._eePltvConfigV2 || {};
  setupConfig();

  if (window._eePltvConfigV2.onLoad) {
    window._eePltvConfigV2.onLoad(API);
  }
};

initialize();
export default API;